import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import fetcher from '../../utils/fetcher';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// import timezone from 'dayjs/plugin/timezone';
import query from '../../endpoints/ContentList/pagedContentList.gql';
import ContentGrid from '../../grids/ContentGrid';
import Sidebar from '../../components/Sidebar/Sidebar';
import ContentList from '../../endpoints/ContentList/ContentList';
import { getServerSession } from 'next-auth';
import { authOptions } from 'pages/api/auth/[...nextauth]';
import setPageCacheHeaders from '../../utils/setPageCacheHeaders';

dayjs.extend(utc);

const ContentPage = ({ data, date, today, errorCode }) => {
  if (errorCode) return <ErrorPage statusCode={errorCode} />;
  let pageTopic = 'Content';
  return (
    <ContentGrid
      h1Text={`Stories from ${date}`}
      sidebar={<Sidebar pageTopic={pageTopic} />}
    >
      <div id="mainContent"></div>
      <ContentList data={data} date={date} today={today} />
    </ContentGrid>
  );
};

export async function getServerSideProps({ query: { date }, req, res }) {
  const altdate = date.replaceAll('-', '/');
  const dateTime = dayjs(altdate);
  const today = dayjs(new Date());
  const variables = {
    contentAreaSlug: process.env.CONTENT_AREA_SLUG,
    startDate: `${dateTime.format('YYYY-MM-DDT00:00:00Z')}`,
    endDate: `${dateTime.format('YYYY-MM-DDT23:59:59Z')}`,
  };
  let errorCode = null;
  try {
    // Fetch content list and session in parallel — see story/[...slug].js
    // for explanation of why this reduces TTFB.
    const [data, session] = await Promise.all([
      fetcher(query, variables),
      getServerSession(req, res, authOptions),
    ]);

    if (!data.contentList?.items) {
      if (res) res.statusCode = 404;
      errorCode = 404;
    }
    setPageCacheHeaders(res, session);
    return {
      props: {
        data,
        date: dateTime.format('MMMM D, YYYY'),
        today: today.format('YYYY-MM-DD'),
        errorCode,
        session,
      },
    };
  } catch (e) {
    console.error(e);
    if (res) res.statusCode = 500;
    errorCode = 500;
    setPageCacheHeaders(res, null);
    return {
      props: {
        data: {},
        date: dateTime.format('MMMM D, YYYY'),
        today: today.format('YYYY-MM-DD'),
        errorCode,
      },
    };
  }
}

ContentPage.propTypes = {
  data: PropTypes.object,
  date: PropTypes.string,
  today: PropTypes.string,
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default ContentPage;
